// Map backdrop: a tiled "Green Arabia" grass texture with a framed border.
// Display only — nothing here affects movement or collision.
export const BORDER_WIDTH = 7;

export const drawTerrain = (ctx, pattern, width, height) => {
  ctx.fillStyle = pattern;
  ctx.fillRect(0, 0, width, height);
};

// Drawn inset from the edge so the stroke isn't half-clipped by the canvas.
export const drawMapBorder = (ctx, width, height) => {
  ctx.lineWidth = BORDER_WIDTH;
  ctx.strokeStyle = "#3b2a18";
  ctx.strokeRect(
    BORDER_WIDTH / 2,
    BORDER_WIDTH / 2,
    width - BORDER_WIDTH,
    height - BORDER_WIDTH
  );

  ctx.lineWidth = 2;
  ctx.strokeStyle = "rgba(216, 186, 126, 0.5)";
  ctx.strokeRect(
    BORDER_WIDTH + 1,
    BORDER_WIDTH + 1,
    width - BORDER_WIDTH * 2 - 2,
    height - BORDER_WIDTH * 2 - 2
  );
};
